import { Ref, forwardRef } from 'react';
import { CheckboxProps, CheckboxRef } from 'antd';
import { DataTestIdProxy } from 'common/components/Utilities/DataTestIdProxy';
import { SCheckbox } from './Checkbox.style';
import { CheckboxGroup } from './CheckboxGroup';

export const InternalCheckbox = forwardRef(
  ({ children, dataTestId, ...restProps }: CheckboxProps & { dataTestId?: string }, ref: Ref<CheckboxRef>) => (
    <DataTestIdProxy dataTestId={dataTestId}>
      <SCheckbox {...restProps} ref={ref}>
        {children}
      </SCheckbox>
    </DataTestIdProxy>
  ),
);

export const Checkbox = Object.assign(InternalCheckbox, {
  Group: CheckboxGroup,
});
